import { render } from "./PlaytronPageRelease.vue?vue&type=template&id=0e161cec&scoped=true&class=row"
import script from "./PlaytronPageRelease.vue?vue&type=script&lang=js"
export * from "./PlaytronPageRelease.vue?vue&type=script&lang=js"

import "./PlaytronPageRelease.vue?vue&type=style&index=0&id=0e161cec&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e161cec"]])

export default __exports__